// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"08c89472","711":"254f4df5"}[chunkId] + ".chunk.js";
};